<template>
  <div class="image-upload-demo">
    <h2>ImageUpload 组件调试页</h2>

    <section class="image-upload-demo__section">
      <h3>基础上传</h3>
      <image-upload
        v-model="basicImage"
        :upload-data="{ category: 'DEMO' }"
      />
      <div class="image-upload-demo__result">
        <span>输出：</span>
        <span>{{ basicImage }}</span>
      </div>
    </section>

    <section class="image-upload-demo__section">
      <h3>裁剪上传（580x360）</h3>
      <image-upload
          :maxSize="307200000"
        v-model="cropImage"
        :upload-data="{ category: 'DEMO' }"
        :enable-crop="true"
        :crop-options="cropOptions"
        tip="建议尺寸：580 x 360，文件大小不超过 300KB"
      />
      <div class="image-upload-demo__result">
        <span>输出：</span>
        <span>{{ cropImage }}</span>
      </div>
    </section>

    <section class="image-upload-demo__section">
      <h3>多图上传</h3>
      <image-upload
        v-model="multiImages"
        :limit="3"
        :upload-data="{ category: 'DEMO' }"
        :enable-crop="true"
        :crop-options="{ fixed: true, fixedNumber: [1, 1] }"
      />
      <div class="image-upload-demo__result">
        <span>输出：</span>
        <span>{{ multiImages }}</span>
      </div>
    </section>
  </div>
</template>

<script>
import ImageUpload from "@/components/image-upload/ImageUpload.vue";

export default {
  name: "ImageUploadDemo",
  components: {
    ImageUpload,
  },
  data() {
    return {
      basicImage: "",
      cropImage: "",
      multiImages: [],
      cropOptions: {
        fixed: true,
        fixedNumber: [580, 360],
      },
    };
  },
};
</script>

<style scoped>
.image-upload-demo {
  padding: 24px;
}

.image-upload-demo__section {
  margin-bottom: 32px;
  border: 1px solid #efefef;
  padding: 16px;
  border-radius: 8px;
}

.image-upload-demo__section h3 {
  margin-bottom: 16px;
  font-size: 16px;
}

.image-upload-demo__result {
  margin-top: 12px;
  font-size: 14px;
  color: #606266;
  word-break: break-all;
}
</style>

